// extracted by mini-css-extract-plugin
export var container = "UKPriceTable_container__TjW2K";
export var numberColumn = "UKPriceTable_numberColumn__YwGXm";
export var row = "UKPriceTable_row__heVN0";
export var table = "UKPriceTable_table__I6RAz";
export var textColumn = "UKPriceTable_textColumn__G6dU6";